import { Icon, IconProps } from '@elkaso-app/web-design';
import { BiBarcodeReader } from 'react-icons/bi';

export const ProductIcon = (props: IconProps) => {
  return <Icon as={BiBarcodeReader} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
